import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { routeNames } from '../../../shared/route-names';
import { UserService } from '../../user/services/user.service';

export const SuperAdminGuard = () => {
  const router = inject(Router);
  const userService = inject(UserService);

  return (userService.getUser()?.getValue()?.id && userService.getUser()?.getValue()?.isSuperAdmin())
    ? true
    : router.navigateByUrl(routeNames.login);
};
